import script from "./Tswiper.vue?vue&type=script&setup=true&lang=js"
export * from "./Tswiper.vue?vue&type=script&setup=true&lang=js"

import "./Tswiper.vue?vue&type=style&index=0&id=33fedc92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33fedc92"]])

export default __exports__